import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const year = new Date().getFullYear();

  const footerCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <footer className="bg-background-900">
      <div className="w-full px-4 md:px-6 pt-14 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <Link to="/" className="flex items-center gap-2.5 mb-4 group cursor-pointer">
              <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
                <i className="ri-book-open-line text-background-50 text-base"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-50 whitespace-nowrap">
                韩漫网
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed mb-4">
              免费韩国漫画在线阅读平台
            </p>
            <p className="text-foreground-400 text-sm leading-relaxed">
              海量韩漫资源，每日更新
            </p>
            <p className="text-foreground-400 text-sm leading-relaxed mt-1">
              随时随地，畅享漫画世界
            </p>
          </div>

          <div>
            <h4 className="text-foreground-300 text-xs font-semibold uppercase tracking-widest mb-5">
              漫画分类
            </h4>
            <div className="flex flex-col gap-2.5">
              {footerCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-foreground-400 hover:text-foreground-200 text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-foreground-300 text-xs font-semibold uppercase tracking-widest mb-5">
              快速链接
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-foreground-400 hover:text-foreground-200 text-sm transition-colors cursor-pointer whitespace-nowrap">
                首页
              </Link>
              <Link to="/category/all" className="text-foreground-400 hover:text-foreground-200 text-sm transition-colors cursor-pointer whitespace-nowrap">
                全部漫画
              </Link>
              <Link to="/#latest" className="text-foreground-400 hover:text-foreground-200 text-sm transition-colors cursor-pointer whitespace-nowrap">
                最新更新
              </Link>
              <Link to="/about" className="text-foreground-400 hover:text-foreground-200 text-sm transition-colors cursor-pointer whitespace-nowrap">
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-foreground-300 text-xs font-semibold uppercase tracking-widest mb-5">
              关注我们
            </h4>
            <div className="flex items-center gap-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-accent-500 text-foreground-300 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-accent-500 text-foreground-300 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-accent-500 text-foreground-300 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
            <p className="text-foreground-500 text-xs mt-5 leading-relaxed">
              客服邮箱：hello@yxhaomai.com
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-xs">
              &copy; {year} 韩漫网 - 免费韩国漫画在线阅读平台 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-foreground-500 hover:text-foreground-300 text-xs transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
                用户协议
              </a>
              <a href="#" className="text-foreground-500 hover:text-foreground-300 text-xs transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-foreground-500 hover:text-foreground-300 text-xs transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
                版权声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}